import React from 'react'
import { Field } from 'redux-form/immutable'

import ProfileFormAvatarInput from './ProfileFormAvatarInput'
import ProfileFormFirstNameInput from './ProfileFormFirstNameInput'
import ProfileFormLastNameInput from './ProfileFormLastNameInput'
import ProfileFormEmailInput from './ProfileFormEmailInput'

import './styles.scss'
const bc = 'profile-general'

const ProfileGeneral = () => (
  <div className={bc}>
    <Field name="avatar" component={ProfileFormAvatarInput} />
    <div className={`${bc}__inputs`}>
      <div className={`${bc}__row`}>
        <Field name="firstName" component={ProfileFormFirstNameInput} />
        <Field name="lastName" component={ProfileFormLastNameInput} />
      </div>
      <div className={`${bc}__row`}>
        <Field name="email" component={ProfileFormEmailInput} />
      </div>
    </div>
  </div>
)

export default ProfileGeneral
